import React, { Component } from 'react';

import {LOGIN_SUPER_ADMIN_GROUP,LOGIN_AFFILIATE_GROUP,LOGIN_CLIENT_GROUP} from '../../../configs/staticConfigs'; 
import {LBL_FOOTER_COPYRIGHT_TEXT,LBL_FOOTER_BROWSER_TEXT,LBL_FOOTER_BROWSER_NAMES} from '../../../configs/labelConfigs'; 


class FooterComponent extends Component {

    constructor(props){
        super();

        this.state = { 
            frompage:''
        }
    }

    render() {
        const {userGroup} = this.props;
        let footerTextClass = "footer-text";
        let footerTextBrowserClass = "footer-text-browser";

        if(userGroup==LOGIN_AFFILIATE_GROUP) {
            footerTextClass += " footer-text-affiliate";
            footerTextBrowserClass += " footer-text-browser-affiliate";
        }
        else if(userGroup==LOGIN_CLIENT_GROUP) {
            footerTextClass += " footer-text-client";
            footerTextBrowserClass += " footer-text-browser-client";
        }
        else if(userGroup==LOGIN_SUPER_ADMIN_GROUP) {
            footerTextClass += " footer-text-super";
            footerTextBrowserClass += " footer-text-browser-super";
        }
        else {
            footerTextClass += " footer-text-common";
        }

         
        return (
            <div>
                <div className={footerTextClass} >{LBL_FOOTER_COPYRIGHT_TEXT}<br/> 
                {LBL_FOOTER_BROWSER_TEXT} <span className={footerTextBrowserClass}>{LBL_FOOTER_BROWSER_NAMES}</span>
                </div>
            </div>
        );
    }
}

export default FooterComponent;